import React from "react";
import Edit from "../../../../assets/images/editinput.svg";
import {Select} from "@appkit4/react-components/select";
import PropTypes from 'prop-types';

function VendorContactInformation(props) {
  let {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    ThirdPartyUserList,
    getTPContact,
    role,
    spocDropdownData,
    handleSelectSpocDropdown,
    editScreen,
    dropdownFlag
  } = props;
  let disabledFields;
  let disabledFieldsVendorContact = false;
  if (role === "analyst" || role === "manager") {
    disabledFields = true
  }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }
  if (role === "businessUser") {
    disabledFieldsVendorContact = true;
  }
  return (
    <div>
      <div className="row m-0">
        {/* <div className="col-sm-6">
          <div className="cv-input-field-container">
            <label className="cv-input-label">
              First Name<span className="asterisk-required">*</span>
            </label>
            <input
              className="cv-input-field leftPadding"
              onBlur={handleBlur}
              type="text"
              value={values.firstName}
              onChange={handleChange("firstName")}
              name="firstName"
              placeholder={"Please enter First Name"}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.firstName && touched.firstName && (
            <div className="form-label error">{errors.firstName}</div>
          )}
        </div> */}

        <div className="col-sm-6">
          <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
              First Name<span className="asterisk-required">*</span>
            </label>
            {(values.firstNameID !== 0 && role === "businessUser") ? (
              <Select
                showSearchOnToggle={true}
                dropdownRenderMode="portal"
                searchable={true}
                className="cv-input-field"
                value={ values.firstNameID}
                data={ThirdPartyUserList}
                valueKey="user_id"
                labelKey="user_name"
                placeholder={"Select/Add New Third Party User"}
                onSelect={(e) => {
                  getTPContact(e);
                  handleChange("firstNameID")({ target: { value: e } });
                }}
                name="firstNameID"
                disabled={disabledFields}
              >
              </Select>
            ) : (
              <>
                <input
                  className={disabledFields ? "cv-input-field-disabled pl-2" :"cv-input-field pl-2"}
                  type="text"
                  value={values.firstName}
                  onChange={handleChange("firstName")}
                  name="firstName"
                  placeholder="Add New Third Party User"
                  disabled={disabledFields}
                ></input>
                <span
                  class="Appkit4-icon icon-right-chevron-fill pointer"
                  title="Select Existing Third Party"
                  onClick={(e) =>
                    handleChange("firstNameID")({
                      target: { value: null },
                    })
                  }
                ></span>
              </>
            )}
          </div>
          {errors.firstName && touched.firstName && (
            <div className="form-label error">{errors.firstName}</div>
          )}
          {errors.firstNameID && touched.firstNameID && (
            <div className="form-label error">{errors.firstNameID}</div>
          )}
        </div>

        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="LastNameContact" className="cv-input-label">
              Last Name<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="LastNameContact"
              type="text"
              value={values.lastName}
              onChange={handleChange("lastName")}
              name="lastName"
              placeholder={"Please enter Last Name"}
              disabled={role === "businessUser" && values.firstNameID !== 0 ? disabledFieldsVendorContact : disabledFields}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.lastName && touched.lastName && (
            <div className="form-label error">{errors.lastName}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="BusinessDesignationContact" className="cv-input-label">
              Business Designation<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="BusinessDesignationContact"
              type="text"
              value={values.designation}
              onChange={handleChange("designation")}
              name="vendorname"
              placeholder={"Please enter Business Designation"}
              disabled={role === "businessUser" && values.firstNameID !== 0 ? disabledFieldsVendorContact : disabledFields}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.designation && touched.designation && (
            <div className="form-label error">{errors.designation}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="EmailContact" className="cv-input-label">
              Email<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="EmailContact"
              type="email"
              value={values.email}
              onChange={handleChange("email")}
              name="email"
              placeholder={"Please enter Email"}
              disabled={role === "businessUser" && values.firstNameID !== 0 ? disabledFieldsVendorContact : disabledFields}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.email && touched.email && (
            <div className="form-label error">{errors.email}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="PhoneNumberContact" className="cv-input-label">
              Phone Number<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="PhoneNumberContact"
              type="tel"
              value={values.vendorPhoneNumber}
              onChange={handleChange("vendorPhoneNumber")}
              name="vendorPhoneNumber"
              placeholder={"Please enter Phone Number"}
              disabled={role === "businessUser" && values.firstNameID !== 0 ? disabledFieldsVendorContact : disabledFields}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.vendorPhoneNumber && touched.vendorPhoneNumber && (
            <div className="form-label error">{errors.vendorPhoneNumber}</div>
          )}
        </div>
          {editScreen ? (
            <div className="col-sm-6">
            <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-spoc-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
                Add More Spocs<span className="asterisk-required">*</span>
            </label>
            <Select
            dropdownRenderMode="portal"
            data={spocDropdownData}
            className="cv-input-field-spocs"
            placeholder={"Add More Spocs"}
            disabled={disabledFields}
            value={dropdownFlag ? true : false}
            onSelect={handleSelectSpocDropdown}
            ></Select>
            </div>
          </div>
          ) : (
            <div className="col-sm-6">
            <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-spoc-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
                Add More Spocs<span className="asterisk-required">*</span>
            </label>
            <Select
            dropdownRenderMode="portal"
            data={spocDropdownData}
            className="cv-input-field-spocs"
            placeholder={"Add More Spocs"}
            disabled={disabledFields}
            defaultValue={false}
            onSelect={handleSelectSpocDropdown}
            ></Select>
            </div>
          </div>
          )}
      </div>
    </div>
  );
}
VendorContactInformation.propTypes = {
  values: PropTypes.object,
  touched:PropTypes.object,
  errors:PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  role:PropTypes.string,
  ThirdPartyUserList:PropTypes.array,
  spocDropdownData: PropTypes.any,
  getTPContact:PropTypes.func,
  handleSelectSpocDropdown: PropTypes.any,
  editScreen: PropTypes.any,
  dropdownValue: PropTypes.any
  }
export default VendorContactInformation;
